import { Select } from "antd";

import immovableAssets from "./immovableAssets";
import movableAssets from "./movableAssets.json";

type Props = {
  id?: string;
  value: string;
  invalid?: boolean;
  isAssetTypeImmovable: boolean;
  onChange: (assetClass: string) => void;
  className?: string;
};

export const BusinessAssetClassSelect = ({
  id = "assetClass",
  value,
  isAssetTypeImmovable,
  invalid = false,
  onChange,
  className,
}: Props) => {
  const options = (isAssetTypeImmovable ? immovableAssets : movableAssets).map(
    ({ assetClass }) => ({
      value: assetClass,
      label: assetClass,
    })
  );

  return (
    <Select
      showSearch
      id={id}
      value={value}
      onChange={onChange}
      status={invalid ? "error" : undefined}
      style={{ width: "100%" }}
      options={options}
      className={className}
    />
  );
};
